
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "BlockInterface": [
      "AwardTypeBlockRowType",
      "BlockAccordionType",
      "BlockAppDownloadType",
      "BlockAutoplayType",
      "BlockBannerType",
      "BlockChapterOpenerType",
      "BlockDataSheetType",
      "BlockDividerType",
      "BlockDocumentHeaderType",
      "BlockErrorType",
      "BlockExternalLinkType",
      "BlockHighlightType",
      "BlockInstagramType",
      "BlockIntegrationType",
      "BlockJsonType",
      "BlockKeyValueTableType",
      "BlockMediaComparisonSliderType",
      "BlockMediaGalleryType",
      "BlockMediaSingleImageType",
      "BlockOfficeVCardType",
      "BlockPdfPreviewType",
      "BlockPricingTableType",
      "BlockQuotesType",
      "BlockRichTextType",
      "BlockSeEekType",
      "BlockSeFeatureImagesType",
      "BlockSePriceType",
      "BlockSeQualityDescriptionType",
      "BlockVideoType",
      "BlockVideoWithDescriptionType",
      "ButtonTypeBlockRowType",
      "ConsumptionValueTypeBlockRowType",
      "KeyFactSmallBlockRowType",
      "KeyFactTypeBlockRowType",
      "KpiTypeBlockRowType",
      "VehicleDataTableSectionTypeBlockRowType"
    ],
    "ButtonInterface": [
      "ContactFormTriggerButtonType",
      "CopyButtonType",
      "DialogButtonType",
      "DocButtonType",
      "DownloadButtonType",
      "HrefButtonType",
      "NestedContentButtonType"
    ],
    "CtaInterface": [
      "CtaForm",
      "CtaLink"
    ],
    "DocumentTypeMobRecordTypeErrorType": [
      "DocumentType",
      "ErrorType",
      "MobRecordType"
    ],
    "ExposeFolderTypeErrorType": [
      "ErrorType",
      "ExposeFolderType"
    ],
    "ExposeFolderTypeLinkType": [
      "ExposeFolderType",
      "LinkType"
    ],
    "HrefButtonTypeCopyButtonTypeDownloadButtonTypeDocButtonTypeNestedContentButtonType": [
      "CopyButtonType",
      "DocButtonType",
      "DownloadButtonType",
      "HrefButtonType",
      "NestedContentButtonType"
    ],
    "KpiInterface": [
      "KpiNumberType",
      "KpiTextType"
    ],
    "LinkTypeErrorType": [
      "ErrorType",
      "LinkType"
    ],
    "SuccessTypeErrorType": [
      "ErrorType",
      "SuccessType"
    ],
    "XCCCCupraDataTypeErrorType": [
      "ErrorType",
      "XCCCCupraDataType"
    ],
    "XCCCSeatDataTypeErrorType": [
      "ErrorType",
      "XCCCSeatDataType"
    ],
    "XCCollectionInterface": [
      "XCollectionAutomotiveType",
      "XCollectionSeType"
    ],
    "XCDgaDataAudiTypeErrorType": [
      "ErrorType",
      "XCDgaDataAudiType"
    ],
    "XCDgaDataVwTypeErrorType": [
      "ErrorType",
      "XCDgaDataVwType"
    ],
    "XCDgaDataVwnTypeErrorType": [
      "ErrorType",
      "XCDgaDataVwnType"
    ],
    "XCDisclaimerInterface": [
      "XCDocDisclaimerType",
      "XCInfoFootnoteType",
      "XCRectangleFootnoteType"
    ],
    "XCFolderDocumentInterface": [
      "XCCCCupraDataType",
      "XCCCSeatDataType",
      "XCDgaDataAudiType",
      "XCDgaDataVwType",
      "XCDgaDataVwnType",
      "XCExternalLinkDataType",
      "XCGenericCodeDataType",
      "XCNwDataType",
      "XCPricingTableType",
      "XCSeDataType",
      "XCUploadDataAttachmentType",
      "XCUploadDataImageGalleryType"
    ]
  }
};
      export default result;
    